import React from "react";

const BreadcrumbsContainer = ({ children, isMobile }) => (
    <div className="breadcrumbs-container">
        <nav aria-label="breadcrumb" className="breadcrumb-container">
            <ol
                className={`breadcrumb ${isMobile ? "b4" : "b3"}`}
                itemScope
                itemType="http://schema.org/BreadcrumbList"
            >
                {children}
            </ol>
        </nav>
    </div>
);

export default BreadcrumbsContainer;
